import type { AxiosInstance } from 'axios';
import type { ApiRentalListingFull } from 'src/types/rental';

import { useQuery, queryOptions } from '@tanstack/react-query';

import axios from 'src/utils/axios';
import { READ_TIMEOUT_MS } from 'src/utils/requestError';

import { QueryKeys } from './QueryKeys';
import { LIVE_STALE_TIME } from './staleness';
import { askUnlessServerAnswered } from './serverRendered';

/** A car for rent as a query (`GET /buyer/rentals/:id`) — asked by the hook below and by the server's render of its page. */
export const rentalListingQuery = (id: string, http: Pick<AxiosInstance, 'get'> = axios) =>
  queryOptions({
    queryKey: QueryKeys.rentalListing(id),
    queryFn: async (): Promise<ApiRentalListingFull> => {
      // One segment of the path, whatever the address held (see `listingQuery`).
      const response = await http.get<ApiRentalListingFull>(`/buyer/rentals/${encodeURIComponent(id)}`, {
        timeout: READ_TIMEOUT_MS,
      });
      return response.data;
    },
    staleTime: LIVE_STALE_TIME,
  });

/** A single rental listing for the detail/booking screen (GET /buyer/rentals/:id). */
export function useRentalListing(id: string) {
  return useQuery({ ...rentalListingQuery(id), refetchOnMount: askUnlessServerAnswered });
}
